module.exports = __webpack_public_path__ + "media/assets/player/little-caret-6d624892cb1194a1d2509aef001086e4.png";